// Wholesaler credit (N.J.A.C. 13:2-24.4): max 30 days from delivery. An unpaid invoice past due
// leads to a Notice of Obligation and, if still unpaid, statewide C.O.D. status.

import { addDays, daysBetween, type IsoDate } from './dates.js';

export const CREDIT_DAYS = 30;

/** Bill due date. `creditDays` comes from the store's state rules (New Jersey: 30). */
export function billDueDate(deliveryDate: IsoDate, creditDays: number = CREDIT_DAYS): IsoDate {
  return addDays(deliveryDate, creditDays);
}

export type CreditUrgency = { level: 'ok' | 'info' | 'warning' | 'critical'; daysLeft: number; message: string };

/** Alert thresholds: 7 days (info), 3 days (warning), 1 day or overdue (critical). */
export function creditUrgency(dueDate: IsoDate, today: IsoDate): CreditUrgency {
  const daysLeft = daysBetween(today, dueDate);
  if (daysLeft < 0) return { level: 'critical', daysLeft, message: `Overdue by ${-daysLeft} day(s) — C.O.D. risk` };
  if (daysLeft <= 1) return { level: 'critical', daysLeft, message: `Due ${daysLeft === 0 ? 'today' : 'tomorrow'} — pay to avoid C.O.D.` };
  if (daysLeft <= 3) return { level: 'warning', daysLeft, message: `Due in ${daysLeft} days` };
  if (daysLeft <= 7) return { level: 'info', daysLeft, message: `Due in ${daysLeft} days` };
  return { level: 'ok', daysLeft, message: `Due in ${daysLeft} days` };
}
